import React, { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import { publicService, type PublicCourse } from '../../services/publicService';
import { useTenant } from '../../context/TenantContext';

interface Value {
  courses: PublicCourse[];
  loaded: boolean;
}

const Ctx = createContext<Value>({ courses: [], loaded: false });

export const MarketingDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { tenantId } = useTenant();
  const [courses, setCourses] = useState<PublicCourse[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoaded(false);
    publicService
      .getPublicCourses(tenantId ?? undefined)
      .then(data => {
        if (cancelled) return;
        setCourses(data);
        setLoaded(true);
      })
      .catch(() => {
        if (cancelled) return;
        setCourses([]);
        setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [tenantId]);

  const value = useMemo(() => ({ courses, loaded }), [courses, loaded]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useMarketingCourses = () => useContext(Ctx);
